import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=e31e81c4&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31e81c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e31e81c4')) {
      api.createRecord('e31e81c4', component.options)
    } else {
      api.reload('e31e81c4', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=e31e81c4&scoped=true&", function () {
      api.rerender('e31e81c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tYiBcKRkTnqP/JS/comp/Voucher-Unit.vue"
export default component.exports